// A0 - Ünite 2: Sayılar & Uçuş Bilgileri
// Hedef: Sayılar 1-100+, saat söyleme, uçuş bilgileri

export const A0_UNIT_2 = {
  'A0-U2-L1': {
    id: 'A0-U2-L1',
    title: 'Sayılar 1-20',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '🔢 Sayılar 1-10',
          table: {
            headers: ['Sayı', 'İngilizce', 'Okunuşu', 'Türkçe'],
            rows: [
              ['1', 'one', '/wʌn/', 'bir'],
              ['2', 'two', '/tuː/', 'iki'],
              ['3', 'three', '/θriː/', 'üç'],
              ['4', 'four', '/fɔːr/', 'dört'],
              ['5', 'five', '/faɪv/', 'beş'],
              ['6', 'six', '/sɪks/', 'altı'],
              ['7', 'seven', '/ˈsevən/', 'yedi'],
              ['8', 'eight', '/eɪt/', 'sekiz'],
              ['9', 'nine', '/naɪn/', 'dokuz'],
              ['10', 'ten', '/ten/', 'on']
            ]
          }
        },
        {
          type: 'grammar',
          title: '🔢 Sayılar 11-20',
          table: {
            headers: ['Sayı', 'İngilizce', 'Okunuşu', 'Not'],
            rows: [
              ['11', 'eleven', '/ɪˈlevən/', 'DİKKAT: Düzensiz'],
              ['12', 'twelve', '/twelv/', 'DİKKAT: Düzensiz'],
              ['13', 'thirteen', '/ˌθɜːˈtiːn/', '-teen takısı'],
              ['14', 'fourteen', '/ˌfɔːˈtiːn/', '-teen takısı'],
              ['15', 'fifteen', '/ˌfɪfˈtiːn/', 'five → fif-teen'],
              ['16', 'sixteen', '/ˌsɪksˈtiːn/', '-teen takısı'],
              ['17', 'seventeen', '/ˌsevənˈtiːn/', '-teen takısı'],
              ['18', 'eighteen', '/ˌeɪˈtiːn/', 'eight-een (tek t)'],
              ['19', 'nineteen', '/ˌnaɪnˈtiːn/', '-teen takısı'],
              ['20', 'twenty', '/ˈtwenti/', '-ty takısı başlıyor']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 13-19 sayılarında vurgu "-teen" hecesindedir: thirTEEN, fourTEEN, fifTEEN...'
        },
        {
          type: 'example',
          title: '✈️ Havacılık Örnekleri',
          items: [
            { en: 'Gate 5 (Gate Five)', tr: '5 Numaralı Kapı' },
            { en: 'Row 12 (Row Twelve)', tr: '12. Sıra' },
            { en: 'Seat 18A (Seat Eighteen A)', tr: '18A Koltuğu' },
            { en: 'Flight at 14:00 (fourteen hundred)', tr: 'Saat 14:00 Uçuşu' }
          ]
        }
      ],
      exercises: [
        {
          type: 'matching',
          instruction: 'Sayıları İngilizceleriyle eşleştirin',
          pairs: [
            { left: '7', right: 'seven' },
            { left: '11', right: 'eleven' },
            { left: '15', right: 'fifteen' },
            { left: '20', right: 'twenty' },
            { left: '13', right: 'thirteen' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '12 nasıl yazılır?',
          options: ['ten-two', 'twelve', 'twelf', 'twelv'],
          correctIndex: 1
        },
        {
          type: 'fillBlank',
          sentences: [
            { text: 'Row ___ (14)', answer: 'fourteen' },
            { text: 'Gate ___ (8)', answer: 'eight' },
            { text: 'Seat ___ (17)', answer: 'seventeen' }
          ]
        }
      ]
    }
  },

  'A0-U2-L2': {
    id: 'A0-U2-L2',
    title: 'Sayılar 21-100 ve Büyük Sayılar',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '🔢 Onluk Sayılar (20-90)',
          table: {
            headers: ['Sayı', 'İngilizce', 'Okunuşu'],
            rows: [
              ['20', 'twenty', '/ˈtwenti/'],
              ['30', 'thirty', '/ˈθɜːti/'],
              ['40', 'forty', '/ˈfɔːti/'],
              ['50', 'fifty', '/ˈfɪfti/'],
              ['60', 'sixty', '/ˈsɪksti/'],
              ['70', 'seventy', '/ˈsevənti/'],
              ['80', 'eighty', '/ˈeɪti/'],
              ['90', 'ninety', '/ˈnaɪnti/']
            ]
          }
        },
        {
          type: 'grammar',
          title: '🔢 Birleşik Sayılar',
          explanation: '21-99 arası sayılar: ONLUK + BİRLİK (tire ile)',
          examples: [
            '21 = twenty-one',
            '35 = thirty-five',
            '47 = forty-seven',
            '68 = sixty-eight',
            '99 = ninety-nine'
          ]
        },
        {
          type: 'grammar',
          title: '🔢 Büyük Sayılar',
          table: {
            headers: ['Sayı', 'İngilizce', 'Havacılık Kullanımı'],
            rows: [
              ['100', 'one hundred', 'Uçuş irtifası: FL100'],
              ['200', 'two hundred', '200 yolcu'],
              ['350', 'three hundred fifty', 'FL350'],
              ['1000', 'one thousand', '1000 mil'],
              ['35000', 'thirty-five thousand', '35,000 feet']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 DİKKAT: "forty" yazılışında "u" YOKTUR! (four → forty, fourteen DEĞİL)'
        },
        {
          type: 'example',
          title: '✈️ Uçak Örnekleri',
          items: [
            { en: 'Boeing 737 (seven three seven)', tr: 'Boeing 737' },
            { en: 'Airbus A320 (A three twenty)', tr: 'Airbus A320' },
            { en: '35,000 feet (thirty-five thousand feet)', tr: '35.000 fit irtifa' },
            { en: '180 passengers', tr: '180 yolcu' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          sentences: [
            { text: '45 = ___-five', answer: 'forty' },
            { text: '73 = seventy-___', answer: 'three' },
            { text: '100 = one ___', answer: 'hundred' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '40 nasıl yazılır?',
          options: ['fourty', 'forty', 'forthy', 'fourtey'],
          correctIndex: 1,
          explanation: 'Doğru cevap FORTY\'dir. Dikkat: "four" kelimesinden farklı olarak "u" harfi yoktur!'
        },
        {
          type: 'multipleChoice',
          question: '"eighty-six" hangi sayı?',
          options: ['68', '86', '816', '806'],
          correctIndex: 1
        }
      ]
    }
  },

  'A0-U2-L3': {
    id: 'A0-U2-L3',
    title: 'Sıra Sayıları (Ordinal Numbers) & Koltuk Numaraları',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '🔢 Sıra Sayıları',
          explanation: 'Sıra sayıları "kaçıncı?" sorusuna cevap verir.',
          table: {
            headers: ['Sayı', 'Sıra', 'Kısa', 'Örnek'],
            rows: [
              ['1', 'first', '1st', 'first class'],
              ['2', 'second', '2nd', 'second row'],
              ['3', 'third', '3rd', 'third exit'],
              ['4', 'fourth', '4th', 'fourth seat'],
              ['5', 'fifth', '5th', 'fifth gate'],
              ['6', 'sixth', '6th', 'sixth flight'],
              ['7', 'seventh', '7th', '-'],
              ['8', 'eighth', '8th', 'DİKKAT: t yok'],
              ['9', 'ninth', '9th', 'DİKKAT: e yok'],
              ['10', 'tenth', '10th', '-']
            ]
          }
        },
        {
          type: 'grammar',
          title: '🔢 Daha Büyük Sıra Sayıları',
          explanation: 'Çoğu sayı için "-th" eklenir:',
          examples: [
            '11th = eleventh',
            '12th = twelfth (twelve → twelfth)',
            '13th = thirteenth',
            '20th = twentieth',
            '21st = twenty-first',
            '22nd = twenty-second',
            '23rd = twenty-third',
            '30th = thirtieth'
          ]
        },
        {
          type: 'tip',
          content: '💡 KURAL: 1st, 2nd, 3rd özeldir. 4-20 ve sonrası "-th" alır. Ama 21st, 22nd, 23rd, 31st... yine özel!'
        },
        {
          type: 'example',
          title: '✈️ Havacılık Örnekleri',
          items: [
            { en: 'Row 15 - the fifteenth row', tr: '15. sıra' },
            { en: 'Seat 23A - twenty-third row, seat A', tr: '23. sıra, A koltuğu' },
            { en: 'First class', tr: 'Birinci sınıf' },
            { en: 'Second officer', tr: 'İkinci pilot' },
            { en: 'Third exit', tr: 'Üçüncü çıkış' }
          ]
        }
      ],
      exercises: [
        {
          type: 'matching',
          instruction: 'Sayıları sıra halleriyle eşleştirin',
          pairs: [
            { left: '1', right: 'first' },
            { left: '2', right: 'second' },
            { left: '3', right: 'third' },
            { left: '5', right: 'fifth' },
            { left: '12', right: 'twelfth' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '21. nasıl yazılır?',
          options: ['twenty-oneth', 'twenty-first', 'twentyth-one', 'twenty-one-th'],
          correctIndex: 1
        },
        {
          type: 'fillBlank',
          sentences: [
            { text: '3rd = ___', answer: 'third' },
            { text: '8th = ___', answer: 'eighth' },
            { text: '15th = ___', answer: 'fifteenth' }
          ]
        }
      ]
    }
  },

  'A0-U2-L4': {
    id: 'A0-U2-L4',
    title: 'Saat Söyleme (Time) - 24 Saat Sistemi',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '⏰ Saat Sorma',
          examples: [
            'What time is it? (Saat kaç?)',
            'What\'s the time?',
            'Do you have the time?',
            'What time does the flight depart? (Uçuş saat kaçta kalkıyor?)'
          ]
        },
        {
          type: 'grammar',
          title: '⏰ 12 Saat Sistemi',
          table: {
            headers: ['Saat', 'İngilizce', 'Not'],
            rows: [
              ['09:00', 'nine o\'clock', 'AM = sabah'],
              ['09:15', 'nine fifteen / quarter past nine', 'çeyrek geçiyor'],
              ['09:30', 'nine thirty / half past nine', 'buuk'],
              ['09:45', 'nine forty-five / quarter to ten', 'çeyrek var'],
              ['21:00', 'nine o\'clock PM', 'PM = akşam']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ 24 Saat Sistemi (Havacılık)',
          explanation: 'Havacılıkta 24 saat sistemi kullanılır. Saatler tek tek söylenir.',
          table: {
            headers: ['Saat', 'Söylenişi', 'Alternatif'],
            rows: [
              ['06:00', 'zero six hundred', 'oh six hundred'],
              ['09:30', 'zero nine thirty', 'oh nine thirty'],
              ['12:00', 'twelve hundred', 'noon'],
              ['14:30', 'fourteen thirty', 'two thirty PM'],
              ['18:45', 'eighteen forty-five', '-'],
              ['23:00', 'twenty-three hundred', '-'],
              ['00:00', 'zero zero hundred', 'midnight']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 HAVACLIK: Saatler genellikle "hundred" ile biter. 14:00 = "fourteen hundred" veya "one four zero zero"'
        },
        {
          type: 'example',
          title: '✈️ Uçuş Saatleri',
          items: [
            { en: 'Departure: 14:30 (fourteen thirty)', tr: 'Kalkış: 14:30' },
            { en: 'Arrival: 18:45 (eighteen forty-five)', tr: 'Varış: 18:45' },
            { en: 'Boarding: 13:50 (thirteen fifty)', tr: 'Biniş: 13:50' },
            { en: 'Gate closes: 14:10 (fourteen ten)', tr: 'Kapı kapanış: 14:10' }
          ]
        }
      ],
      exercises: [
        {
          type: 'matching',
          instruction: 'Saatleri eşleştirin',
          pairs: [
            { left: '09:00', right: 'nine o\'clock' },
            { left: '14:30', right: 'fourteen thirty' },
            { left: '12:00', right: 'twelve hundred' },
            { left: '18:45', right: 'eighteen forty-five' }
          ]
        },
        {
          type: 'multipleChoice',
          question: 'Havacılıkta 15:00 nasıl söylenir?',
          options: ['three o\'clock', 'fifteen hundred', 'three PM', 'fifteen PM'],
          correctIndex: 1
        },
        {
          type: 'fillBlank',
          sentences: [
            { text: 'Departure: 08:30 = zero eight ___', answer: 'thirty' },
            { text: 'Arrival: 22:00 = twenty-two ___', answer: 'hundred' }
          ]
        }
      ]
    }
  },

  'A0-U2-L5': {
    id: 'A0-U2-L5',
    title: 'Uygulama: Uçuş Bilgisi Verme',
    type: 'practice',
    content: {
      sections: [
        {
          type: 'scenario',
          title: '✈️ Senaryo: Yolcuya Uçuş Bilgisi',
          dialogues: [
            {
              speaker: 'Yolcu',
              text: 'Excuse me, when does the flight depart?',
              translation: 'Affedersiniz, uçuş ne zaman kalkıyor?'
            },
            {
              speaker: 'Kabin Memuru',
              text: 'Flight TK1920 departs at fourteen thirty from Gate B12.',
              translation: 'TK1920 uçuşu saat 14:30\'da B12 kapısından kalkıyor.'
            },
            {
              speaker: 'Yolcu',
              text: 'What is my seat number?',
              translation: 'Koltuk numaram nedir?'
            },
            {
              speaker: 'Kabin Memuru',
              text: 'You are in row twenty-three, seat A. That\'s 23A, a window seat.',
              translation: 'Siz yirmi üçüncü sırada, A koltuğundasınız. Yani 23A, pencere kenarı.'
            },
            {
              speaker: 'Yolcu',
              text: 'What time do we arrive?',
              translation: 'Saat kaçta varıyoruz?'
            },
            {
              speaker: 'Kabin Memuru',
              text: 'We arrive at eighteen forty-five local time.',
              translation: 'Yerel saatle on sekiz kırk beşte varıyoruz.'
            }
          ]
        },
        {
          type: 'vocabulary',
          title: '📚 Uçuş Bilgi Kelimeleri',
          words: [
            { en: 'flight number', tr: 'uçuş numarası' },
            { en: 'gate', tr: 'kapı' },
            { en: 'row', tr: 'sıra' },
            { en: 'seat', tr: 'koltuk' },
            { en: 'departure', tr: 'kalkış' },
            { en: 'arrival', tr: 'varış' },
            { en: 'boarding time', tr: 'biniş saati' },
            { en: 'window seat', tr: 'pencere kenarı' },
            { en: 'aisle seat', tr: 'koridor kenarı' },
            { en: 'middle seat', tr: 'orta koltuk' }
          ]
        }
      ],
      exercises: [
        {
          type: 'roleplay',
          instruction: 'Aşağıdaki bilgileri İngilizce söyleyin',
          items: [
            { info: 'Uçuş: TK456, Kapı: A5, Saat: 16:20', answer: 'Flight TK four five six, Gate A five, sixteen twenty' },
            { info: 'Koltuk: 31B, Sıra: 31, Koridor', answer: 'Seat thirty-one B, row thirty-one, aisle seat' }
          ]
        },
        {
          type: 'fillBlank',
          sentences: [
            { text: 'The flight ___ at 09:30. (kalkıyor)', answer: 'departs' },
            { text: 'We ___ at 14:00. (varıyoruz)', answer: 'arrive' },
            { text: 'Your seat is 15A, a ___ seat. (pencere)', answer: 'window' }
          ]
        }
      ]
    }
  },

  'A0-U2-EXAM': {
    id: 'A0-U2-EXAM',
    title: '📝 Ünite 2 Sınavı',
    type: 'exam',
    content: {
      timeLimit: 15,
      passingScore: 80,
      questions: [
        {
          type: 'multipleChoice',
          question: '15 nasıl yazılır?',
          options: ['fiveteen', 'fifteen', 'fiften', 'fivteen'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: '40 nasıl yazılır?',
          options: ['fourty', 'forty', 'forthy', 'fortie'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: '3rd nasıl okunur?',
          options: ['three', 'threeth', 'third', 'thirdth'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'Havacılıkta 14:00 nasıl söylenir?',
          options: ['two o\'clock', 'fourteen o\'clock', 'fourteen hundred', 'two PM'],
          correctIndex: 2
        },
        {
          type: 'fillBlank',
          question: '21st = twenty-___',
          answer: 'first'
        },
        {
          type: 'fillBlank',
          question: '12 = ___',
          answer: 'twelve'
        },
        {
          type: 'multipleChoice',
          question: '"aisle seat" ne demek?',
          options: ['pencere kenarı', 'koridor kenarı', 'orta koltuk', 'ön koltuk'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Row 23 nasıl söylenir?',
          options: ['row twenty-three', 'row two three', 'row twentieth-third', 'row twenty-third'],
          correctIndex: 0
        }
      ]
    }
  }
};

export default A0_UNIT_2;
